// Canonical issue-severity vocabulary — shared by IssueSeverity (Phase 1
// per-row indicator) and IssueEvidencePanel (Phase 4 review surface). The
// dot palette is the only coloured element; the matching text label is
// kept neutral so severity reads as a rank rather than a pill.
//
// Centralising both maps closes the previous drift between Phase 1's
// `slate-300` "low" tone and Phase 4's accidental `slate-400`. Any future
// severity-rendering surface should import from here so the dot story
// stays consistent end-to-end.

import type { IssueSeverity } from "../../../../types";

/** Tailwind background class for the severity dot, by level. Hairline-only
 *  by brand carve-out (≤8 px), no accent-fill budget consumed. */
export const ISSUE_SEVERITY_DOT_CLASS: Record<IssueSeverity, string> = {
  critical: "bg-red-600",
  high: "bg-amber-500",
  medium: "bg-sky-500",
  low: "bg-slate-300",
};

/** Display label for the severity, by level. */
export const ISSUE_SEVERITY_LABEL: Record<IssueSeverity, string> = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
};
